export default "__VITE_ASSET__Bev$TQ00__"